import React, { useState } from 'react';
import NewsCard from '../components/NewsCard';
import newsData from '../components/NewsData';
import CarouselBanner from '../components/CarouselBanner';
import { motion, AnimatePresence } from "framer-motion";
import './css/Home.css';

interface QuestionItem {
    question: string;
    answer: string;
}

const FaChevronDown = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
    </svg>
);

const FaChevronUp = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
    </svg>
);

const featuredNews = [...newsData].reverse().slice(0, 3);

const questions: QuestionItem[] = [
    {
        question: 'Ямар үйлчилгээ санал болгодог вэ?',
        answer: 'Манайхаас дараах авто үйлчилгээ авах боломжтой:1. Авто машин худалдах, худалдан авах, 2. Авто машин солих, 3. Авто машин түрээс 4. Авто үйлчилгээ, сервис, засвар 5. Авто дэлгүүрийн үйлчилгээ'
    },
    {
        question: 'Танай байршил хаана байдаг вэ?',
        answer: 'Бид Эрдэнэт хот, Баян-Өндөр сум, Говил багт байршилж байна. Google maps - https://maps.app.goo.gl/sDF1jGupNFaYQPvN9.'
    },
    {
        question: 'Та нарын ажлын цаг хэд вэ?',
        answer: 'Бид Даваагаас Ням гарагуудад ажилладаг.'
    },
    {
        question: 'Үнийн санал хэрхэн авах вэ?',
        answer: '1м²-ийн үнэ - 4,500,000₮'
    },
];

const Home: React.FC = () => {
    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const toggleQuestion = (index: number) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="home">
            <div className="hero-section">
                <CarouselBanner />
            </div>

            <div className="home-content">
                <section className="featured-news">
                    <h2 className="section-title">Мэдээ, мэдээлэл</h2>
                    <div className="featured-grid">
                        {featuredNews.map((news) => (
                            <NewsCard
                                key={news.id}
                                id={news.id}
                                image={news.image}
                                title={news.title}
                                summary={news.summary}
                                featured={true}
                            />
                        ))}
                    </div>
                </section>

                <section className="qa-section">
                    <h2 className="section-title">БАЙНГА АСУУДАГ АСУУЛТУУД</h2>
                    <div className="qa-container">
                        <div className="qa-list">
                            {questions.map((q, index) => (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.3, delay: index * 0.1 }}
                                    className={`qa-item ${activeIndex === index ? 'active' : ''}`}
                                    onClick={() => toggleQuestion(index)}
                                >
                                    <div className="qa-question-header">
                                        <h3>{q.question}</h3>
                                        <span className="qa-chevron">
                                            {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                                        </span>
                                    </div>
                                    <AnimatePresence>
                                        {activeIndex === index && (
                                            <motion.div
                                                initial={{ opacity: 0, maxHeight: 0 }}
                                                animate={{ opacity: 1, maxHeight: "1000px" }}
                                                exit={{ opacity: 0, maxHeight: 0 }}
                                                transition={{
                                                    duration: 0.5,
                                                    ease: "easeInOut"
                                                }}
                                                className="qa-answer"
                                            >
                                                {q.answer}
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Home;